// import React from 'react';
// import Bgimage from "../../images/EXPLORE DIVISIONS/steel-logo-2.jpg"; 

// function OurExpertise() {
//   return (
//     <div>
//       <div className="mx-auto text-center md:py-2">
//         <section
//           className="w-full bg-cover bg-center bg-no-repeat text-white rounded-lg py-2 md:py-16"
//           style={{ backgroundImage: `url(${Bgimage})` }} 
//         >
//           <div className="gap-6 items-center">
//             <div className="p-2 md:p-6 rounded-lg"> 
//               <h2 className="text-3xl md:text-4xl font-bold mb-2">STEEL STRUCTURE</h2>
//               <p className="sm:p-4 md:p-7 rounded-lg text-lg md:text-2xl md:px-28">
//               High-strength steel used in construction and engineering for durability, stability, and load-bearing
//               support in buildings, bridges, and industrial structures.
//               </p>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// }

// export default OurExpertise;

import React from "react";
import Indusone from "../../images/steel-image/one.jpg";
import AktVideo from "../Akt-SteelStructure-Video"
import AlternateLogo from "../../images/logos/stell-logo (2)(4).png";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-3 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            {/* Image placed naturally in the flow */}
            <div className="flex justify-center mb-2">
              <img
                src={AlternateLogo}
                alt="Offshore Industry"
                className="w-[300px] md:w-[400px] md:h-[200px] transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>

            <p className="text-sm md:text-sm text-justify">
              High-strength steel is a critical material in construction and engineering, valued for its exceptional durability and ability to withstand extreme stress. It is specifically designed to provide stability and load-bearing support in a wide range of structures, including buildings, bridges, and industrial frameworks.
              By integrating this advanced material, we ensure that structures are built to last, maintaining their integrity and performance over time. Whether in high-rise buildings or heavy-duty infrastructure, high-strength steel plays a pivotal role in creating safe, reliable, and long-lasting engineering solutions.
            </p>
          </div>

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>

        </div>
        <div className='text-center mt-4 mb-2 max-w-3xl mx-auto'>
          <h2
            className="text-2xl md:text-4xl font-bold text-white"
          // style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
          >
            Structural Framework Process
          </h2>
        </div>
        <div>
          <AktVideo />
        </div>
      </div>

    </div>
  );
}

export default OurExpertise;


